import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { useAppStateStore } from '@/features/application'
import router from '@/router'
import { useDossierStore } from './useDossierStore'

export function useDossierRoutingService() {
  const store = useDossierStore()

  async function loadStoreWithKey(key: any): Promise<boolean> {
    try {
      await store.loadData(key)
      return true
    } catch {
      return false
    }
  }

  function navigateToWithKey(key: any) {
    const appState = useAppStateStore()
    const context = TypesContextesAutorisesEnum[appState.contextCourant]
    router.push(`/${context}/dossier/${key}`)
  }

  function navigateToRechercheDossierList() {
    if (window.history.state.back) {
      router.go(-1)
    } else {
      const appState = useAppStateStore()
      const context = TypesContextesAutorisesEnum[appState.contextCourant]
      router.push(`/${context}/dossiers`)
    }
  }

  return { loadStoreWithKey, navigateToWithKey, navigateToRechercheDossierList }
}

